import { setToken } from './client';

const TENANT_BASE = (import.meta.env.VITE_TENANT_API_BASE as string) || '/api/tenant/v1';

interface Envelope<T> {
  success: boolean;
  data?: T;
  code?: string;
  message?: string;
}

export interface TenantSession {
  token: string;
  betaToken?: string;
  uid: string;
  tenantKey: string;
  group: string;
  status: string;
  isLegacy?: boolean;
}

export interface TenantFrontendConfig {
  tenantKey: string;
  brandName: string;
  defaultGroup: string;
  features: { usernameRegister: boolean; strategySelection: boolean };
}

async function tenantRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
  const gatewayToken = localStorage.getItem('tenant_gateway_token') || '';
  const response = await fetch(`${TENANT_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(gatewayToken ? { Authorization: `Bearer ${gatewayToken}` } : {}),
      ...options.headers,
    },
  });
  const result = await response.json() as Envelope<T>;
  if (!response.ok || !result.success || !result.data) {
    const error = new Error(result.message || `HTTP ${response.status}`) as Error & { code?: string };
    error.code = result.code;
    throw error;
  }
  return result.data;
}

export function getTenantFrontendConfig() {
  return tenantRequest<TenantFrontendConfig>('/frontend/config');
}

export async function registerTenant(data: {
  name: string;
  password: string;
  qrCode?: string;
}): Promise<TenantSession> {
  const session = await tenantRequest<TenantSession>('/auth/register', {
    method: 'POST',
    headers: { 'Idempotency-Key': crypto.randomUUID() },
    body: JSON.stringify({ ...data, qrCode: data.qrCode || 'DEFAULT' }),
  });
  localStorage.setItem('tenant_gateway_token', session.token);
  setToken(session.betaToken || session.token);
  localStorage.setItem('tenant_key', session.tenantKey);
  localStorage.setItem('beta_uid', session.uid);
  return session;
}

export async function loginTenant(name: string, password: string): Promise<TenantSession> {
  const session = await tenantRequest<TenantSession>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ name, password }),
  });
  localStorage.setItem('tenant_gateway_token', session.token);
  setToken(session.betaToken || session.token);
  localStorage.setItem('tenant_key', session.tenantKey);
  localStorage.setItem('beta_uid', session.uid);
  return session;
}
